import { useEffect, useState } from 'react'
import { logError } from '../services/error/logger'

const tsMaintenanceStatusUrl = `${import.meta.env.VITE_THOUGHTSPOT_HOST}/api/rest/2.0/system/banner`

const useTSMaintenanceStatus = () => {
  const [isTSUnderMaintenance, setIsTSUnderMaintenance] = useState(false)
  const [loading, setLoading] = useState(true)
  const noMaintenanceMessage = 'This system is functioning normally. No maintenance is in progress.'

  const fetchTSMaintenanceStatus = () => {
    const urlWithCacheBuster = `${tsMaintenanceStatusUrl}?${Date.now()}`
    fetch(urlWithCacheBuster)
      .then((response) => response.json())
      .then((data: { under_maintenance: boolean; message?: string; banner_text?: string }) => {
        if ('message' in data && typeof data.message === 'string') {
          if (data.message === noMaintenanceMessage) {
            setIsTSUnderMaintenance(false)
            return
          }
        }

        if ('banner_text' in data && typeof data.banner_text === 'string') {
          if (data.banner_text === noMaintenanceMessage) {
            setIsTSUnderMaintenance(false)
            return
          }
        }

        if ('under_maintenance' in data && typeof data.under_maintenance === 'boolean') {
          setIsTSUnderMaintenance(data.under_maintenance)
        }
      })
      .catch((error: unknown) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        logError(error instanceof Error ? error : new Error(String(error)))
      })
      .finally(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    fetchTSMaintenanceStatus()
    const intervalId = setInterval(fetchTSMaintenanceStatus, 300000)
    return () => clearInterval(intervalId)
  }, [])

  return { isTSUnderMaintenance, loading }
}

export default useTSMaintenanceStatus
